import {useContext} from "react";
import {NetworkStateContext} from "./../context";

export function useNetworkState() {
    return useContext(NetworkStateContext);
}